import {registerMPElement} from 'common/util/register-element';
import {Component, ConfigOptions} from 'panel';

import Tooltip from '../tooltip';
import {UserListAttrs} from './types';
import template from './index.jade';
import css from './index.styl?inline';

export default class UserList extends Component<{}, {}, unknown, UserListAttrs> {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      users: {type: `json`, description: `Expects an Array<{name: string}> to iterate over and create 'mp-user-icon'`},
      clickable: {type: `boolean`, description: `Have the component emit click events and apply basic hover styles`},
      'show-tooltip': {type: `boolean`, default: true},
      'tooltip-placement': Tooltip.attrsSchema[`placement`],
      'more-text': {
        type: `string`,
        description: `Text to display after count when the number of items is greater than 'show-max'`,
        default: `more`,
      },
      'show-max': {
        type: `number`,
        default: 7,
        description: `Maximum number of icons to show before replacing with the truncated text`,
      },
    };
  }

  get config(): ConfigOptions<{}, {}, UserListAttrs> {
    return {
      css,
      template,
      useShadowDom: true,
      defaultState: {},
      helpers: {
        handleUserIconClick: (user) => this.dispatchEvent(new CustomEvent(`userClick`, {detail: {user}})),

        handleMoreTextClick: () => this.dispatchEvent(new CustomEvent(`moreTextClick`)),
      },
    };
  }
}

registerMPElement(`mp-user-list`, UserList);
